import React, {useEffect} from 'react';
import AppModalDialog from '../../components/AppModalDialog/AppModalDialog';
import RenderPage from '../../RenderPage';
import {updateCurrentModalPage} from '../../redux/app-state-slice';

function WebComponentEntry({customerData, appConfig, dispatch,maintenanceStatus}) {
  useEffect(() => {
    if(maintenanceStatus) {
      dispatch(updateCurrentModalPage('/maintenance'));
    }
  }, [maintenanceStatus]);
  const getContent = () => (
    <div id='prequal--web--app'>
      <div className='prequal--web--app prequal--wc--app'>
        <div className='prequal--web--form-container'>
          <RenderPage appConfig={appConfig} customerData={customerData} dispatch={dispatch} />
        </div>
      </div>
    </div>
  );
  return (
    <div className='prequal--web--landing-page-container' role='main'>
      {customerData.indexSource.value === 'componentButton' ? (
        <>
          {customerData.showModalFlag.value && (
            <AppModalDialog content={() => getContent()} customerData={customerData} appConfig={appConfig} />
          )}
        </>
      ) : (
        <> {getContent()} </>
      )}
    </div>
  );
}

export default WebComponentEntry;
